import { useMachine } from '@xstate/react'
import { UpdateProps } from 'api/update'
import {
  requestMachine,
  RequestMachineContext,
  RequestMachineEventData,
  RequestMachineStates,
} from 'machines/requestMachine'
import { useUsersActions } from 'providers'
import { useCallback } from 'react'
import { State } from 'xstate'

export const useUpdate = (): [
  State<RequestMachineContext, RequestMachineEventData, RequestMachineStates>,
  (formData: UpdateProps['formData']) => Promise<any>
] => {
  const [state, send] = useMachine(requestMachine)
  const { update: updateUser } = useUsersActions()

  const update = useCallback(
    async (formData: UpdateProps['formData']) => {
      const promise = updateUser({ formData })
      send('SET_PROMISE', { data: promise })
    },
    [send, updateUser]
  )
  return [state, update]
}
